import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import uniqueId from 'lodash/uniqueId';
import './styles.css';
import FiltersContentLoader from '../../../../components/FiltersContentLoader';
import LoadMask from '../../../../components/LoadMask';
import PagePagination from '../../../../components/PagePagination';
import ENDPOINT from '../../../../constants/endpoints';
import LinkBuilder from '../../../../helpers/link-builder';
import {useGrid} from '../../../../hooks/useGrid';

const CandidateProfileViewed = props => {
  const { id } = props;
  const {
    data: { isFetching, rows, rowsCount, page, perPage, TotalViewsCount },
    actions: { readPage, fetch },
  } = useGrid(ENDPOINT.COLLECTION.CANDIDATE_PROFILE_VIEW, null, false);

  useEffect(() => {
    fetch({ id });
  }, []);

  const renderRecords = useMemo(
    () =>
      rows.map(record => {
        const link =
          record.FirmActive === 'Yes'
            ? LinkBuilder.getFirmLink(record.FirmUrlAlias)
            : null;
        return (
          <div className="profile-viewed-block__item" key={uniqueId()}>
            {link ? (
              <NavLink to={link} className="profile-viewed-block__item-title">
                {record.FirmName}
              </NavLink>
            ) : (
              <h5 className="profile-viewed-block__item-title">
                {record.FirmName}
              </h5>
            )}
            <span className="profile-viewed-block__item-views">
              {`${record.ViewsCount} view${
                parseInt(record.ViewsCount) !== 1 ? 's' : ''
              }`}
            </span>
            <span className="profile-viewed-block__item-date">
              {`Latest: ${record.DateView}`}
            </span>
          </div>
        );
      }),
    [rows]
  );

  return !isFetching ? (
    Number(rowsCount) > 0 ? (
      <div className="sidebar__widget">
        {isFetching && <LoadMask relative />}
        <h3 className="profile-viewed-block__title">
          Profile Viewed:{' '}
          <span className="profile-viewed-block__total-views-link">
            {TotalViewsCount}{' '}
            {`time${parseInt(TotalViewsCount) !== 1 ? 's' : ''}`}
          </span>
        </h3>
        <p className="profile-viewed-block__sub-title">
          Firms that have viewed this profile.
        </p>
        <div className="profile-viewed-block__list">{renderRecords}</div>
        {Number(rowsCount) > Number(perPage) && (
          <div className="profile-viewed-block__pagination">
            <PagePagination
              page={page}
              perPage={perPage}
              count={rowsCount}
              pageRangeDisplayed={3}
              controlFunc={readPage}
              hideFirstLastPages={false}
              hideNavigation={true}
              minimalStyle={true}
              scrollToTop={false}
            />
          </div>
        )}
      </div>
    ) : null
  ) : (
    <FiltersContentLoader />
  );
};

CandidateProfileViewed.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CandidateProfileViewed;
